import { render, staticRenderFns } from "./DefaultOne.vue?vue&type=template&id=9d637204"
import script from "./DefaultOne.vue?vue&type=script&lang=js"
export * from "./DefaultOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports